import axios from '~/constants/axiosConfig';

const obterTokenZendesk = async () => {
  try {
    const response = await axios.get(`zendesk/obtertokenzendesk`);
    return response.data.conteudo;
  } catch (error) {
    console.log('Erro ao obter o Token Zendesk', error);
    throw error;
  }
};

const construirUrl = async () => {
  const token = await obterTokenZendesk();
  return `https://eauditoria.zendesk.com/access/jwt?jwt=${token}&return_to=https://eauditoria.zendesk.com/hc/pt-br/requests/`;
};

export async function aberturaTicketNovo() {
  window.open((await construirUrl()) + 'new/', '__blank');
}

export async function gestaoTicketNovo() {
  window.open(await construirUrl(), '__blank');
}
